<template>
  <div>
    <div
      class="component-header-top d-flex justify-content-between align-items-center"
    >
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center" style="margin-right:  30px">
          <img src="@/static/icon/header-top/home.svg" alt="">
          <img class="pl-2" src="@/static/icon/header-top/logo-head.svg" alt="">
        </div>
        <div>
          <!-- MENU CHA -->
          <div class="menu-parent">
            <el-link
              v-for="parent in filteredMenu"
              :key="parent.key"
              :underline="false"
              :href="getParentHref(parent)"
              :class="{ active: isActiveParent(parent) }"
              @click.native="onClickParent($event, parent)"
              class="mr-3"
            >
              <div class="name_menu d-flex align-items-center">
                <img class="icon-menu" :src="parent.icon" alt="">
                <span>{{ parent.text }}</span>
              </div>
            </el-link>
          </div>
        </div>
        <!--      // phần menu -->
      </div>
      <div class="d-flex align-items-center">
        <div class="seach-global-select-lang">
          <el-select v-model="accountInfo.language" @change="changeLang()">
            <el-option
              v-for="item in langList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="seach-global">
          <div class="exchange-rate">
            <span>{{ language.common_exchange_rate }}. : {{ accountInfo.cny_exchange_rate | vnd2 }} Vnđ / ¥ - {{ accountInfo.usd_exchange_rate | vnd2 }} Vnđ/ USD </span>
          </div>
        </div>

        <div class="px-2 number-noti">
          <el-badge :value="total_unseen_message" class="item">
            <img @click="showListChat()" style="width: 20px; height: 20px; cursor: pointer" src="@/static/icon/chat/head_chat.svg" alt="">
          </el-badge>
        </div>

        <div class="px-2 number-noti">
          <el-badge :value="accountInfo.total_noti_unread" class="item">
            <img @click="showNoti()" style="width: 20px; height: 20px; cursor: pointer" src="@/static/icon/header-top/bell.svg" alt="">
          </el-badge>
        </div>

        <div
          class="dropdown-account"
          ref="dropdownProfile"
          @click="showMenuTop = !showMenuTop"
        >
          <img
            v-if="accountInfo.avatar"
            :src="baseMedia + accountInfo.avatar"
            class="avatar"
          />
          <span v-else><img class="avatar-null" src="@/static/icon/header-top/account.svg"/></span>
          <span class="name">
        {{ accountInfo.name }}
        <img class="down" src="@/static/icon/header-top/down.svg"/>
      </span>
          <ul v-if="showMenuTop">
            <a>
              <span style="color: #007AFF">{{ accountInfo.name }}</span>
            </a>
            <a @click="changePassWord()">
              <span>{{ language.user_change_password }}</span>
            </a>
            <a @click.stop.stop="confirmLogout">
              <span>{{ language.common_logout }}</span>
            </a>


          </ul>
        </div>


      </div>
    </div>
    <!-- MENU CON -->
    <!-- MENU CON (CẤP 2) -->
    <div class="menu-child" v-if="currentChildren.length">
      <div
        v-for="(child, index) in currentChildren"
        :key="`${child.name}-${index}`"
        class="menu-child-item"
      >
        <el-link
          :underline="false"
          :href="child.url"
          :class="{ activeC: isActiveChild(child) }"
          @click.native="onClickChild($event, child)"
        >
          <div class="flex-center">
            <span>{{ child.text }}</span>
            <!-- Icon chỉ báo nếu có menu cấp 3 -->
            <i v-if="child.children && child.children.length" class="el-icon-arrow-down ml-1 icon-sub"></i>
          </div>
        </el-link>

        <!-- MENU CẤP 3 (Sẽ xuất hiện khi hover vào .menu-child-item) -->
        <div
          v-if="child.children && child.children.length"
          class="menu-child-level3"
        >
<!--          :class="{ activeC: isMatchRoute(subChild) }"-->
          <el-link
            v-for="(subChild, index) in getFilteredSubChildren(child.children)"
            :key="subChild.name + '-' + index"
            :underline="false"
            :href="subChild.url"

            @click.native="onClickChild($event, subChild)"
            class="level3-item"
          >
            <span>{{ subChild.text }}</span>
          </el-link>
        </div>
      </div>
    </div>

    <div class="dialog-no-close">
      <el-dialog
        top="150px"
        width="30%"
        :visible.sync="dialogChangePassWord"
        :show-close="false"
        :close-on-click-modal="false"
        border
      >
        <ChangePassword
          @cancelChange="cancelChange"
        ></ChangePassword>
      </el-dialog>
    </div>

    <div class="dialog-no-close">
      <el-dialog
        top="150px"
        width="45%"
        :visible.sync="dialogNoti"
        :show-close="false"
        border
      >
        <div class="titleLog" style="text-align: center; font-weight: 700; color: #007AFF; padding-bottom: 20px">
          <span>{{ language.common_notifi }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center btn-filter-noti">
            <span :class="filter.un_read == 0 ? 'active-un-read' : ''" @click="filterUnread(0)">{{ language.common_all }}</span>
            <span :class="filter.un_read == 1 ? 'active-un-read' : ''" @click="filterUnread(1)">{{ language.common_unread }}</span>
          </div>
          <div class="d-flex align-items-center" style="cursor: pointer; font-weight: 500; font-size: 12px" @click="clickAllNoti()">
            <i class="el-icon-check"></i>
            <span class="pl-1">{{ language.common_mark_all }}</span>
          </div>
        </div>
        <el-scrollbar ref="scrollContainer" height="300px">
          <div style="height: 300px; overflow-y: auto" class="scroll-content" v-infinite-scroll="fetchNoti" :infinite-scroll-disabled="isLoading || !hasMore">
            <div v-for="item in listNoti" :key="item.id" class="item">
              <div @click="seenNotiOne(item)" class="d-flex justify-content-between align-items-center content-noti-quote" :class="item.time_seen == 0 ? 'time0' : ''">
                <div class="d-flex align-items-center">
                  <div class="round-box"></div>
                  <div class="d-flex align-items-center" style="cursor: pointer">
                    <img class="avatar-null" src="@/static/icon/header-top/account.svg"/>
                    <span class="pl-2 content-noti">{{ item.content }}</span>
                  </div>
                </div>
                <div class="time" style="font-size: 12px">
                  <span>{{ item.time_create }}</span>
                </div>
              </div>
            </div>
            <div v-if="isLoading" class="loading" style="text-align: center"><i class="el-icon-loading"></i></div>
          </div>
        </el-scrollbar>
      </el-dialog>
    </div>

    <div class="btn-chat" @click="showPopupChat()" v-if="!pathChats.includes(path)">
      <img src="@/static/icon/chat/chatBottom2.png" alt="" style="position: relative; width: 120px">
      <div>
        <span class="countBottom" v-if="total_unseen_message > 0">{{ total_unseen_message }}</span>
      </div>
    </div>

    <div class="content-chat-pop-up">
      <el-dialog
        title="Tips"
        :visible.sync="dialogVisibleChat"
        :key="keyOpenChat"
      >
        <PopupChat :dialogVisibleChat="dialogVisibleChat"></PopupChat>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  // import ls from "local-storage";
  import store from "@/store";
  import EventBus from "@/EventBus";
  import PopupChat from "@/views/chat/components/PopupChat";
  import {mapActions, mapGetters} from "vuex";
  import ChangePassword from "@/views/user/ChangePassword";
  import axios from "axios";

  export default {
    name: "LayoutHeaderTop",

    components: {
      ChangePassword,
      PopupChat,
    },
    data() {
      return {
        seach: "",
        showMenuTop: false,
        // phan noti
        dialogChangePassWord: false,
        isLoading: false,
        hasMore: true,
        dialogNoti: false,
        listNoti: [],
        filter: {
          un_read: 0,
          page: 1,
          per_page: 15,
        },

        translateLanguage: {
          search: ''
        },
        baseMedia: process.env.VUE_APP_MEDIA,
        langList: [
          {
            name: "VN",
            value: "vi"
          },
          {
            name: "EN",
            value: "en"
          },
          {
            name: "中文",
            value: "cn"
          },
        ],

        // chat
        pathChats: ['chat-list'],
        dialogVisibleChat: false,
        keyOpenChat: 0,
        isZoomChat: false,
        awaitingConfirmationCount: 0,

        activeParent: 0,
        activeChild: '',
      };
    },
    computed: {
      ...mapGetters(["path", "full_path"]),
      ...mapGetters("account", ["accountInfo", "language"]),
      ...mapGetters(["total_unseen_message"]),
      listMenu() {
        return [
          {
            text: 'Dịch vụ',
            url: "/service/list-of-goods",
            name: "list-of-goods",
            icon: require('@/static/icon/header-top/service.svg'),
            rootPermission: [],
            subcategory: [
              {
                text: 'Tra cứu hàng hóa hải quan',
                url: "/service/list-of-goods",
                name: "list-of-goods",
                rootPermission: ["good-baogia.index",],
                children: [
                  {
                    text: 'Danh sách',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 1,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Biểu thuế',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 2,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Thuế môi trường',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 3,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Thuế TTDB',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 4,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Thuế tự vệ, CBPG',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 5,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Thương hiệu bảo hộ',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 6,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Rủi ro về giá',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 7,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Chính sách',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 8,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Quy đổi đơn vị tính',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 9,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Sản phẩm rủi ro',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 10,
                    rootPermission: ["good-baogia.index"]
                  },
                  {
                    text: 'Phương thức đánh giá',
                    url: "/service/list-of-goods",
                    name: "list-of-goods",
                    tab: 11,
                    rootPermission: ["good-baogia.index"]
                  },
                ],
              },
              {
                text: 'Tạo đơn báo giá',
                url: "/service/list-quote",
                name: "list-quote",
                rootPermission: ['quote-baogia.create',]
              },
              {
                text: this.language.menu_quote_history,
                url: "/service/history-quote",
                name: "history-quote",
                matchPaths: ['/quote-update'],
                rootPermission: ['quote-baogia.index',]
              },
              {
                text: this.language.menu_manager_approval_quote ,
                url: "/service/approval-quote",
                name: "manager-approval-quote",
                rootPermission: [
                  'manager-approval-quote.index-all',
                  'manager-approval-quote.only-conpany',
                  'manager-approval-quote.only-account',
                ],
              },
              {
                text: 'Hàng chờ báo giá' ,
                url: "/service/waiting-for-quote",
                name: "waiting-for-quote",
                rootPermission: [
                  'quote-batch.getList',
                  'quote-batch.getListByUser',
                  'quote-batch.getListAll',
                ],
              },
              {
                text: 'Hàng chờ XNK duyệt' ,
                url: "/service/waiting-for-xnk-approval",
                name: "waiting-for-xnk-approval",
                rootPermission: [
                  'quote-queue-xnk.view-all',
                  'quote-queue-xnk.view-company',
                  'quote-queue-xnk.change-approval',
                  'quote-queue-xnk.approve-all',
                  'quote-queue-xnk.approve-assigned',
                ],
              },
            ],
          },
          {
            text: 'Hải quan',
            url: "customs",
            name: "Customs",
            icon: require('@/static/icon/header-top/hq.svg'),
            rootPermission: [],
            subcategory: [
              {
                text: this.awaitingConfirmationText,
                url: "/customs/goods-awaiting-confirmation",
                name: "goods-awaiting-confirmation",
                rootPermission: [
                  'awaiting-confirmation.view-all',
                  'awaiting-confirmation.view-all-agency',
                ],
              },
              {
                text: this.language.menu_waiting_clearance,
                url: "/customs/goods-awaiting-clearance",
                name: "goods-awaiting-clearance",
                rootPermission: [
                  'quote-clean-baogia.index',
                  'quote-file-baogia.index',
                  'quote-file-baogia.view-wh-release-note',
                ],
                children: [
                  {
                    text: 'Hàng hóa chờ thông quan',
                    url: "/customs/goods-awaiting-clearance",
                    name: "goods-awaiting-clearance",
                    tab: 1,
                    rootPermission: ["quote-clean-baogia.index"]
                  },
                  {
                    text: 'Danh sách file XNK',
                    url: "/customs/goods-awaiting-clearance",
                    name: "goods-awaiting-clearance",
                    tab: 2,
                    rootPermission: ["quote-file-baogia.index"]
                  },
                  {
                    text: 'Phiếu xuất kho',
                    url: "/customs/goods-awaiting-clearance",
                    name: "goods-awaiting-clearance",
                    tab: 3,
                    rootPermission: ["quote-file-baogia.view-wh-release-note"]
                  },
                  {
                    text: 'Hàng tự nhập kho',
                    url: "/customs/goods-awaiting-clearance",
                    name: "goods-awaiting-clearance",
                    tab: 4,
                    rootPermission: [
                      "import-warehouse.index-all",
                      "import-warehouse.index-company",
                      "import-warehouse.index-agency",
                    ]
                  },
                ]
              },
              {
                text: this.language.menu_cleared_custom,
                url: "/customs/goods-cleared-custom",
                name: "goods-cleared-custom",
                rootPermission: [
                  'cleared_custom.index'
                ],
              },
            ],
          },
          {
            text: this.language.menu_accountant,
            url: "/accounting/",
            name: "declaration",
            icon: require('@/static/icon/header-top/accountant.svg'),
            rootPermission: [
              'accountant.index',
            ],
            subcategory: [
              {
                text: 'Chờ duyệt',
                url: "/accounting/calculation-declaration",
                name: "accounting-calculation-declaration",
                rootPermission: [
                  'accountant-pending.index',
                ]
              },
              {
                text: this.language.accountant_tab_declaration,
                url: "/accounting/",
                name: "declaration",
                rootPermission: [
                  'accountant.index',
                ],
              },
              {
                text: this.language.accountant_tab_partner_list,
                url: "/accounting/transport-partners",
                name: "accountant-transport-partners",
                rootPermission: [
                  'accountant-transport-partners.index',
                ],
              },
              {
                text: this.language.accountant_tab_expense_item_list,
                url: "/accounting/expense-items",
                name: "accountant-expense-items",
                rootPermission: [
                  'accountant-expense-items.index',
                ],
              },
              {
                text: this.language.accountant_tab_shipment_list,
                url: "/accounting/shipments",
                name: "accountant-shipments",
                rootPermission: [
                  'accountant-shipments.index',
                ],
              },
              {
                text: this.language.cash_balance_title,
                url: "/accounting/cash-balance",
                name: "accountant-cash-balance",
                rootPermission: [
                  'accountant-cash-funds.index',
                ],
              },
              {
                text: this.language.accountant_pay_title,
                  url: "/accounting/pay",
                name: "accountant-pay",
                rootPermission: [
                  'accountant-pay.index',
                ],
              },

              {
                text: this.language.income_expense_title,
                url: "/accounting/income-expenditure",
                name: "accountant-income-expenditure",
                rootPermission: [
                  'accountant-income-expenses.index',
                ],
              },
              {
                text: this.language.accountant_tab_partner_debt,
                url: "/accounting/partner-debt",
                name: "accountant-partner-debt",
                rootPermission: [
                  'accountant-partner-debts.index',
                ],
              },

            ],
          },
          {
            text: 'Báo cáo',
            url: "/report",
            name: "report",
            icon: require('@/static/icon/header-top/chart.svg'),
            rootPermission: [
              'quote-report.power-rate',
              'quote-report.vipo-approval-performance',
              'quote-report.report-revenue',
            ],
            subcategory: [
              {
                text: 'Hiệu suất duyệt đơn',
                url: "/report/single-browsing-performance",
                name: "report-single-browsing-performance",
                rootPermission: ["quote-report.power-rate"],
              },
              {
                text: 'Hiệu suất duyệt đơn Vipo',
                url: "/report/vipo-approval-performance",
                name: "report-vipo-approval-performance",
                rootPermission: ["quote-report.vipo-approval-performance"],
              },
              {
                text: 'Báo cáo doanh thu',
                url: "/report/revenue",
                name: "report-revenue",
                rootPermission: ["quote-report.report-revenue"],
              },
              {
                text: 'Báo cáo import hàng hóa',
                url: "/report/report-excel-ai",
                name: "report-excel-ai",
                rootPermission: ["quote-report.report-excel-ai"],
              },
              {
                text: 'Báo cáo quản lý duyệt đơn',
                url: "/report/report-approval-quote-today",
                name: "report-approval-quote-today",
                rootPermission: ['quote-report.report-approval-quote-today'],
              },
            ],
          },
          {
            text: this.language.menu_setting,
            url: "/setting",
            name: "setting",
            icon: require('@/static/icon/header-top/setting.svg'),
            rootPermission: [],
            subcategory: [
              {
                text: this.language.menu_user,
                url: "/setting/list-user",
                name: "setting-lists-user",
                rootPermission: ["user-baogia.index"],
              },
              {
                text: 'Danh sách  nhân viên xử lý đơn VIPO',
                url: "/setting/list-user-vpo",
                name: "setting-lists-user-vpo",
                rootPermission: ["quote-batch.listSale"],
              },
              {
                text: this.language.menu_company,
                url: "/setting/list-company",
                name: "setting-lists-company",
                rootPermission: ["company-baogia.index"],
              },
              {
                text: this.language.menu_customer,
                url: "/customers",
                name: "customer",
                rootPermission: ["customer.index"],
              },
              {
                text: this.language.menu_border_gate,
                url: "/setting/border-gate",
                name: "setting-border-gate",
                rootPermission: ["good-line-baogia.index"],
              },
              {
                text: this.language.menu_company_xnk,
                url: "/setting/company-xnk",
                name: "setting-company-xnk",
                rootPermission: ["company-xnk-baogia.index"],
              },
              {
                text: 'Cấu hình HS code - Cty NK',
                url: "/setting/company-import-hs-codes",
                name: "setting-company-import-hs-codes",
                rootPermission: [
                  "seting-company-hs-code.view-all",
                  "seting-company-hs-code.view-all-agency"
                ]
              },
              {
                text: this.language.menu_acceptance_rate,
                url: "/setting/acceptance-rate",
                name: "setting-acceptance-rate",
                rootPermission: ["setting.acceptance-rate"],
              },
              {
                text: this.language.menu_assign_quote_staff,
                url: "/setting/assign-quote-staff",
                name: "setting-assign-quote-staff",
                rootPermission: ["setting.assign-quote-staff"],
              },
              {
                text: "Bảng giá phí dịch vụ",
                url: "/setting/service-price-list",
                name: "setting-service-price-list",
                rootPermission: ["service-price.index"],
              },
              {
                text: this.language.menu_role,
                url: "/setting/account/roles",
                name: "account-roles",
                rootPermission: ["per-baogia.index"],
              },
            ],
          },
        ];
      },
      // menu mới ------------------------------------------------>
      filteredMenu() {
        return this.listMenu
          .map(parent => {
            const hasChildren = Array.isArray(parent.subcategory) && parent.subcategory.length > 0
            if (!hasChildren) {
              return parent
            }
            return {
              ...parent,
              subcategory: parent.subcategory.filter(child =>
                this.hasAnyPermission(child.rootPermission)
              )
            }
          })
          .filter(parent => {
            const originalParent = this.listMenu.find(item => item.name === parent.name)
            const hadChildren = originalParent?.subcategory?.length > 0
            // Menu cha có submenu
            if (hadChildren) {
              return parent.subcategory.length > 0
            }
            // Menu độc lập
            return this.hasAnyPermission(parent.rootPermission)
          })
      },
      currentChildren() {
        const parent = this.filteredMenu.find(parent => {
          if (!parent.subcategory?.length) {
            return false
          }
          return parent.subcategory.some(child =>
            this.isMatchRoute(child)
          )
        })
        return parent ? parent.subcategory : []
      },
      awaitingConfirmationText() {
        const text = this.language.menu_awaiting_confirmation || 'Hàng chờ xác nhận'
        return `${text} (${this.awaitingConfirmationCount})`
      },
    },
    mounted() {
      document.addEventListener("click", this.documentClick);
      this.socketNoti();
      EventBus.$on('zoomPopupChat', this.zoomPopupEvent);
      this.fetchCountUnseenMessage();
      this.fetchAwaitingConfirmationCount();
    },
    destroyed() {
      document.removeEventListener("click", this.documentClick);
    },
    methods: {
      ...mapActions(["setSocketConect"]),
      ...mapActions("account", ["getAccountInfo"]),
      getFilteredSubChildren(children) {
        if (!children) return [];
        return children.filter(sub => this.hasAnyPermission(sub.rootPermission));
      },
      // menu mới
      hasAnyPermission(rootPermission) {
        if (!rootPermission || rootPermission.length === 0) {
          return true
        }
        const permissions = this.accountInfo?.permissions?.map(item => item.name) || []
        return permissions.some(permission =>
          rootPermission.includes(permission)
        )
      },
      fetchAwaitingConfirmationCount() {
        axios.get("awaiting-confirmation", {
          params: {
            page: 1,
            per_page: 1,
          },
        }).then((response) => {
          if (response.code === 200) {
            this.awaitingConfirmationCount = response.data.pagination?.total || response.data.total || 0
          }
        }).catch(() => {
          this.awaitingConfirmationCount = 0
        });
      },
      // LINK CHA
      getDefaultChild(parent) {
        if (!parent.subcategory || parent.subcategory.length === 0) {
          return null
        }

        if (parent.name === 'Customs') {
          return parent.subcategory.find(child =>
            child.name === 'goods-awaiting-clearance'
          ) || parent.subcategory[0]
        }

        return parent.subcategory[0]
      },
      getParentHref(parent) {
        const child = this.getDefaultChild(parent)
        if (child) {
          return child.url
        }
        return parent.url
      },
      // ACTIVE CHA
      isActiveParent(parent) {
        // Có submenu
        if (parent.subcategory && parent.subcategory.length > 0) {
          return parent.subcategory.some(child => this.isMatchRoute(child))
        }
        // Không có submenu
        return this.isMatchRoute(parent)
      },
      isMatchRoute(item) {
        const path = this.$route.path
        // Trùng chính xác
        if (path === item.url) {
          return true
        }
        // Các route mở rộng được khai báo riêng
        if (item.matchPaths?.some(p => path.startsWith(p))) {
          return true
        }
        // Route con
        return path.startsWith(item.url + '/')
      },
      // CLICK CHA
      onClickParent(e, parent) {
        if (!e || e.button !== 0) return
        e.preventDefault()
        // Nếu có menu con -> vào menu con mặc định
        if (parent.subcategory && parent.subcategory.length > 0) {
          const child = this.getDefaultChild(parent)
          this.activeChild = child.name
          if (this.$route.path !== child.url) {
            this.$router.push(child.url)
          }
          return
        }
        // Không có menu con -> vào menu cha
        this.activeChild = parent.name
        if (this.$route.path !== parent.url) {
          this.$router.push(parent.url)
        }
      },
      // ACTIVE CON
      isActiveChild(child) {
        return this.isMatchRoute(child)
      },
      // CLICK CON
      onClickChild(e, child) {
        if (!e || e.button !== 0) return
        e.preventDefault()
        this.activeChild = child.name

        const route = {
          path: child.url,
          query: {}
        }

        if (child.tab) {
          route.query.tab = child.tab
        }

        if (
          this.$route.path !== child.url ||
          this.$route.query.tab !== child.tab
        ) {
          this.$router.push(route)
        }
      },
      // hết phần menu mới ----------------------------------------------------->
      // phần chat
      zoomPopupEvent (val) {
        console.log(val)
        if (val == 'backDetail') {
          this.isZoomChat = false;
          return
        }
        if (val && val.event == 'detailChatList') {
          setTimeout(() => {
            this.$router.push({
              name: "chat-list",
              query: {chat_id: val.chat_id}
            });
          }, 100);
          this.dialogVisibleChat = false;
          return
        }

        this.isZoomChat = !this.isZoomChat;
      },
      showPopupChat () {
        this.keyOpenChat = Date.now();
        this.dialogVisibleChat = true;
      },
      showListChat () {
        this.$router.push({
          name: "chat-list",
        });
      },
      // phan thong bao
      socketNoti() {
        setTimeout(() => {
          // Join vào room
          this.$socket.emit("join-to-room-code", this.accountInfo.code);
        }, 2000);
      },
      showNoti () {
        this.filter.page = 1;
        this.hasMore = true;
        this.isLoading = false;
        this.listNoti = [];
        this.dialogNoti = true;
        this.fetchNoti();
      },
      filterUnread (num) {
        this.listNoti = [];
        this.filter.un_read = num;
        this.filter.page = 1;
        this.isLoading = false;
        this.hasMore = true;
        this.fetchNoti();
      },
      async fetchNoti() {
        if (this.isLoading || !this.hasMore) return;
        this.isLoading = true
        this.loadingLog = true;
        await axios.get("notification", {params: this.filter}).then((response) => {
          this.loadingLog = false;
          switch (response.code) {
            case 200:
              var itemData = response.data.items;
              // phần loading thêm data
              if (itemData.length === 0) {
                this.hasMore = false;
              } else {
                this.listNoti.push(...itemData);
                this.filter.page++;
              }
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
          this.isLoading = false;
        });
      },
      // xem 1 noti
      seenNotiOne(item) {
        if (item.time_seen == 0) {
          axios.post("notification/click-noti/" + item.id).then((response) => {
            switch (response.code) {
              case 200:
                if (this.accountInfo.total_noti_unread > 0) {
                  this.accountInfo.total_noti_unread = this.accountInfo.total_noti_unread - 1;
                }
                this.dialogNoti = false;
                this.showDetailQuote(item)
                break;
              default:
                this.$notify.error({
                  title: "Error",
                  message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
                });
                break;
            }
          });
        } else {
          this.showDetailQuote(item)
        }
      },
      //  xem hết noti
      clickAllNoti() {
        this.listNoti.forEach((i) => {
          i.time_seen = 1
        });
        axios.post("notification/click-all-noti").then((response) => {
          switch (response.code) {
            case 200:
              this.accountInfo.total_noti_unread = 0;
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },

      showDetailQuote(item) {
        const currentRoute = this.$route;
        const targetQuery = { quote_code: item.data.quote_code };

        this.dialogNoti = false;

        if (item.name === 1019) {
          return;
        }


        if (item.name === 1006) {
          if (
            currentRoute.name === "quote-update" &&
            currentRoute.params.quote_id === item.data.quote_id
          ) {
            // Force reload bằng cách chuyển sang route tạm, rồi chuyển lại
            this.$router.replace({ name: "quote-dummy" }).then(() => {
              this.$router.push({
                name: "quote-update",
                params: { quote_id: item.data.quote_id },
              });
            });
          } else {
            this.$router.push({
              name: "quote-update",
              params: { quote_id: item.data.quote_id },
            });
          }
          return;
        }
        if (item.data && (item.name === 1017 || item.name == 1018)) {
          if (currentRoute.name === "manager-approval-quote") {
            this.$router.replace({ name: "quote-dummy" }).then(() => {
              this.$router.push({
                name: "manager-approval-quote",
                params: { quote_code: item.data.quote_code },
              });
            });
          } else {
            this.$router.push({
              name: "manager-approval-quote",
              params: { quote_code: item.data.quote_code },
            });
          }
          return;
        }


        if (
          currentRoute.name === 'history-quote' &&
          currentRoute.query.quote_code === targetQuery.quote_code
        ) {
          // Already on the correct route with the correct query, do nothing
          return;
        }
        if (item.name === 1020) {
          this.downLoadFile(item.id)
          return;
        }

        if (currentRoute.name === 'history-quote') {
          this.$router.replace({
            name: "history-quote",
            query: targetQuery,
          });
        } else {
          this.$router.push({
            name: "history-quote",
            query: targetQuery,
          });
        }
      },


      changePassWord () {
        this.dialogChangePassWord = true;
      },
      cancelChange () {
        this.dialogChangePassWord = false;
      },
      hasPermission(menu) {
        if (menu.rootPermission.length == 0) {
          return true;
        }
        let permissions = [];
        if (
          undefined !== this.accountInfo.permissions &&
          this.accountInfo.permissions.length > 0
        ) {
          this.accountInfo.permissions.forEach((e) => {
            permissions.push(e.name);
          });
        }
        return permissions.some((r) => menu.rootPermission.includes(r));
      },
      hasSubPermission(subMenu) {
        //
        if (subMenu.rootPermission === "") {
          return true;
        }
        let permissions = [];
        if (
          undefined !== this.accountInfo.permissions &&
          this.accountInfo.permissions.length > 0
        ) {
          this.accountInfo.permissions.forEach((e) => {
            permissions.push(e.name);
          });
        }
        //
        return permissions.includes(subMenu.rootPermission);
      },
      moduleIsSelected(modules, path) {
        if (undefined !== path && path.includes(modules)) {
          return true;
        }
        return false;
      },
      // phần chuyển huớng
      nextRouteMenu(item) {
        this.$router.push({name: item.name}).catch(() => {
        });
      },

      documentClick(e) {
        let el = this.$refs.dropdownProfile;
        let target = e.target;
        if (el !== target && !el.contains(target)) {
          this.showMenuTop = false;
        }
      },

      ...mapActions("account", ["removeAccountInfo"], ["getAccountInfo"]),
      confirmLogout() {
        this.$confirm(this.language.common_confirm_logout, this.language.common_warning, {
          confirmButtonText: this.language.common_ok,
          cancelButtonText: this.language.common_cancel,
          type: "warning",
        })
          .then(() => {
            this.removeAccountInfo();
          })
          .catch(() => {
          });
      },
      // đổi ngôn ngữ
      changeLang() {
        let data = {
          language: this.accountInfo.language,
        }
        console.log(data)
        axios.post("account/change-language", data).then((response) => {
          switch (response.code) {
            case 200:
              location.reload()
              break;
            case 422:
              this.$notify({
                title: response.message,
                message: response.message,
                type: "warning",
              });
              break;
            case 400:
              this.$notify({
                title: "Có lỗi xảy ra",
                message: response.errors[0],
                type: "warning",
              });
              break;
              case 500:
                this.$notify({
                title: "có lỗi xảy ra",
                message: response.message,
                type: "warning",
                });
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },
      fetchCountUnseenMessage() {
        axios.get("chat/count/unseen").then((response) => {
          switch (response.code) {
            case 200:
              store.dispatch("setTotalUnseenMessage", response.data);
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },
      downLoadFile(notificationId){
        axios.get(`notification/download-file/${notificationId}`, {
          responseType: 'blob'
        }).then((response) => {
          if (response) {
            this.loadingExportGood = false;
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download","list-goods.xlsx");
            document.body.appendChild(link);
            link.click();
          }
        })
      },
    },

    sockets: {
      connect() {
        this.socketNoti();
        setTimeout(() => {
          this.setSocketConect(true);
        }, 3000);
      },
      disconnect() {
        this.setSocketConect(false);
      },
      "change-stauts-quote-noti": function (data) {
        if (data) {
          this.accountInfo.total_noti_unread += data.count
        }
      },
      "receive-message-to-conversation": function (data) {
        if(data) {
          this.fetchCountUnseenMessage();
        }
      },

      "process-quote-queue-noti": function (data) {
        if (data) {
          EventBus.$emit('reaTimeTotalCheck', data)
        }
      },
    }
  };
</script>

<style lang="css" scoped>
  .component-header-top {
    height: 50px;
    padding: 0px 15px;
  }

  .seach-global {
    min-width: 200px;
  }
  .seach-global .el-select {
    width: 50px;
  }

  .dropdown-account {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 100%;
    padding: 0px 3px 0px 10px;
    position: relative;
  }

  .dropdown-account img {
    margin-right: 8px;
  }

  .dropdown-account .down {
    width: 10px;
    margin-right: 0px;
    margin-left: 5px;
  }

  .dropdown-account .name {
    color: #007AFF;
    font-size: 12px;
  }

  .dropdown-account ul {
    position: absolute;
    top: 50px;
    right: 0px;
    margin: 0px;
    width: 200px;
    background-color: #fff;
    padding: 5px 0px 5px 0px;
    z-index: 1000;
    border: 1px solid #f2f2f2;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05), 0 1px 0 rgba(0, 0, 0, 0.05);
  }

  .dropdown-account ul a {
    list-style-type: none;
    height: 35px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    text-decoration: none;
    color: #2c3e50;
  }

  .dropdown-account ul a:hover {
    background-color: #f2f2f2;
  }

  .dropdown-account ul a.divider {
    height: 1px;
    background-color: #ccc;
    margin-bottom: 5px;
  }

  .name_menu {
    color: #000000;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    margin-right: 10px;
    cursor: pointer;
    height: 40px;
  }

  .name_menu .icon-menu {
    padding-right: 5px;
    width: 20px;
    height: 30px;
  }

  .active {
    border-bottom: 5px solid #007AFF;
  }

  .exchange-rate {
    padding: 5px 10px;
    color: #007AFF;
    font-weight: 500;
    background: #E8F3FF;
  }
  .content-noti-quote {
    padding: 10px;
    margin-bottom: 5px;
  }
  .content-noti {
    font-weight: 600;
    font-size: 13px;
    line-height: 31px;
    letter-spacing: 0px;
  }
  .time0 {
    background: #F5F5F5;
    border-radius: 5px;
  }
  .btn-filter-noti {
    padding: 10px 0;
  }
  .btn-filter-noti span {
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }
  .active-un-read {
    background: #EBF5FF;
    border-radius: 5px;
  }
  .btn-chat {
    position: fixed;
    bottom: 10px;
    right: 0;
    z-index: 99;
    cursor: pointer;
  }
  .countBottom {
    background: red;
    padding: 5px;
    color: #ffffff;
    position: absolute;
    top: 7px;
    right: 30px;
    border-radius: 3px;
  }

  .menu-child {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background: #fff;
    border-top: 1px solid #f0f0f0;
    /*overflow-x: auto;*/
    scrollbar-width: none;
  }

  .menu-child::-webkit-scrollbar {
    display: none;
  }

  .menu-child .el-link {
    flex-shrink: 0;
    text-decoration: none !important;
  }

  .menu-child .el-link .flex-center {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 8px;
    color: #606266;
    font-size: 13px;
    font-weight: 500;
    transition: all .2s ease;
  }

  .menu-child .el-link:hover .flex-center {
    background: #f5f7fa;
  }

  .menu-child .el-link.activeC .flex-center {
    background: #ecf5ff;
    color: #409EFF;
  }

  .menu-child .icon-child {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
  /* Item menu cấp 2 */
  .menu-child-item {
    position: relative;
    text-align: left; /* Chữ căn trái */
  }

  /* Ép phần nội dung bên trong el-link căn trái */
  .menu-child-item .flex-center {
    display: flex;
    align-items: center;
    justify-content: flex-start; /* Căn trái icon và text */
    text-align: left;
  }

  /* Base style cho Popup Menu Cấp 3 */
  .menu-child-level3 {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 220px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid rgba(229, 231, 235, 0.8);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
    padding: 8px;
    z-index: 1000;

    transform: translateY(10px);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
  }

  /* Vùng đệm ẩn giúp giữ hover */
  .menu-child-level3::before {
    content: "";
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 10px;
  }

  /* TRẠNG THÁI HOVER: Hiển thị Popup */
  .menu-child-item:hover .menu-child-level3 {
    opacity: 1;
    visibility: visible;
    transform: translateY(4px);
    pointer-events: auto;
  }

  /* Styling từng item trong Menu Cấp 3 - Căn trái tuyệt đối */
  .level3-item {
    display: flex !important;
    align-items: center;
    justify-content: flex-start; /* Căn trái text cấp 3 */
    text-align: left !important;
    width: 100%;
    padding: 10px 14px !important;
    font-size: 13.5px;
    font-weight: 500;
    color: #4b5563 !important;
    border-radius: 8px;
    transition: all 0.2s ease;
    text-decoration: none !important;
  }

  /* Hover vào Item Cấp 3 */
  .level3-item:hover {
    color: #007aff !important;
    transform: translateX(4px); /* Nhích nhẹ sang phải khi hover */
  }

  /* Item Cấp 3 đang Active */
  .level3-item.activeC {
    background-color: #e6f0ff;
    color: #007aff !important;
    font-weight: 600;
  }

  /* Icon mũi tên chỉ báo menu cấp 3 */
  .icon-sub {
    font-size: 11px;
    margin-left: 6px;
    color: #9ca3af;
    transition: transform 0.25s ease, color 0.25s ease;
  }

  .menu-child-item:hover .icon-sub {
    transform: rotate(180deg);
    color: #007aff;
  }

</style>
<style type="text/css">
  .component-header-top input {
    border-radius: 25px;
    height: 28px;
    font-size: 12px;
    border: none;
  }

  .component-header-top .el-input__icon {
    line-height: 28px;
  }

  .avatar {
    max-width: 100%;
    border-radius: 50%;
    width: 35px;
    height: 35px;
  }

  .seach-global input {
    border: 1px solid #3F92D1;
  }
  .seach-global-select-lang {
    border: 1px solid #3F92D1;
    width: 80px;
    margin-right: 20px;
    border-radius: 20px;
  }

  .avatar-null {
    background: #c2c2c2;
    border-radius: 50%;
  }
  .spanLink {
    color: #000000 !important;
    text-decoration: none;
  }
  .spanLinkSub {
    display: block;
    width: 100%;
    font-size: 12px !important;
  }
  .number-noti .el-badge__content.is-fixed {
    z-index: 1;
  }

  .content-chat-pop-up .el-dialog  {
    position: absolute;
    right: 108px;
    bottom: -20px;
  }
  .content-chat-pop-up .el-dialog {
    width: 450px;
    border-radius: 10px;
    box-shadow: 0px 4px 4px 0px #00000040;
  }
  .content-chat-pop-up .el-dialog__header {
    display: none;
  }
  .content-chat-pop-up .el-dialog__footer {
    display: none;
  }
  .content-chat-pop-up .el-dialog__body {
    padding: 0;
  }
  /*.chat-dialog {
    position: fixed;
    right: 108px;
    bottom: 0;
    transform: scale(1);
    transition: all 0.35s ease;
  }*/

  /* khi zoom */
  .chat-dialog-zoom {
    top: 15px !important;
    width: 100% !important;
    height: 100%;
  }
  .chat-dialog-zoom  .el-dialog {
    width: 95%;
    right: 35px !important;
    transition: all .35s ease;
  }
  .chat-dialog {
    transition:
      right 0.35s ease,
      bottom 0.35s ease,
      transform 0.35s ease,
      width 0.35s ease,
      height 0.35s ease;
  }
</style>
